export const getAlbaniaGateway = () => {
    return ''
}

export const getLivenessGateway = () => {
    return ''
}
